import { render, staticRenderFns } from "./EasingCurveEditor.vue?vue&type=template&id=84bb5b7e&scoped=true&"
import script from "./EasingCurveEditor.vue?vue&type=script&lang=js&"
export * from "./EasingCurveEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bb5b7e",
  null
  
)

export default component.exports